
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import {SectionData} from '@/domains/global/models'

@Component
export default class BreakdownSection extends Vue {
  @Prop({ type: Object, default: null })
  private readonly financialSection?: SectionData


  get show() {
    return (this.financialSection?.show === undefined || !!this.financialSection.show) && this.financialSection?.item.amount
  }

  get visibleChildren() {
    const children = this.financialSection?.children || []
    return children.filter(child => child.show === undefined || !!child.show)
  }
}
